import nexo from '@tiendanube/nexo';

import { IS_LOCAL } from 'commons/utils/constants/env';

const DEFAULT_CLIENT_ID = '7660';

const instance = nexo.create({
  clientId: process.env.REACT_APP_NUVEM_ENVIO_ID ?? DEFAULT_CLIENT_ID,
  log: IS_LOCAL
});
export default instance;
